import React from "react";
import LegalLayout from "@/components/site/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout overline="Rechtliches" title="Datenschutzerklärung">
      <p className="italic text-ink/70">
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
      </p>

      <section data-testid="ds-section-ueberblick">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          1. Datenschutz auf einen Blick
        </h2>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit deinen personenbezogenen Daten passiert, wenn du diese Website
          besuchst. Personenbezogene Daten sind alle Daten, mit denen du
          persönlich identifiziert werden kannst.
        </p>
      </section>

      <section data-testid="ds-section-verantwortliche">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          2. Verantwortliche Stelle
        </h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p className="mt-2">
          Kerstin Cloodt<br />
          Landaustraße 5<br />
          34121 Kassel<br />
          E-Mail:{" "}
          <a
            href="mailto:kerstin.cloodt@googlemail.com"
            className="text-ocean hover:text-terracotta transition-colors"
          >
            kerstin.cloodt@googlemail.com
          </a>
          <br />
          Telefon:{" "}
          <a
            href="tel:+4915168129874"
            className="text-ocean hover:text-terracotta transition-colors"
          >
            0151&nbsp;68129874
          </a>
        </p>
        <p className="mt-2">
          Verantwortliche Stelle ist die natürliche Person, die allein oder
          gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung
          von personenbezogenen Daten entscheidet.
        </p>
      </section>

      <section data-testid="ds-section-hosting">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          3. Hosting
        </h2>
        <p>
          Diese Website wird bei einem externen Dienstleister gehostet. Die
          personenbezogenen Daten, die auf dieser Website erfasst werden,
          werden auf den Servern des Hosters gespeichert. Hierbei kann es sich
          v. a. um IP-Adressen, Kontaktanfragen, Meta- und
          Kommunikationsdaten, Vertragsdaten sowie sonstige Daten handeln, die
          über eine Website generiert werden. Rechtsgrundlage ist Art. 6 Abs.
          1 lit. f DSGVO (berechtigtes Interesse an einer sicheren, schnellen
          und effizienten Bereitstellung des Onlineangebots).
        </p>
      </section>

      <section data-testid="ds-section-rechte">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          4. Deine Rechte
        </h2>
        <p>
          Du hast jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck deiner gespeicherten personenbezogenen Daten zu
          erhalten. Du hast außerdem ein Recht auf Berichtigung oder Löschung
          dieser Daten sowie auf Einschränkung der Verarbeitung und ein
          Widerspruchsrecht. Bitte richte deine Anfrage an die oben genannte
          E-Mail-Adresse.
        </p>
        <p>
          Ferner steht dir ein Beschwerderecht bei der zuständigen
          Aufsichtsbehörde zu (in Hessen: Hessischer Beauftragter für
          Datenschutz und Informationsfreiheit).
        </p>
      </section>

      <section data-testid="ds-section-ssl">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          5. SSL- bzw. TLS-Verschlüsselung
        </h2>
        <p>
          Diese Website nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung.
          Eine verschlüsselte Verbindung erkennst du am „https://" in der
          Adresszeile deines Browsers.
        </p>
      </section>

      <section data-testid="ds-section-kontaktformular">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          6. Kontaktformular
        </h2>
        <p>
          Wenn du mir über das Kontaktformular Anfragen zukommen lässt, werden
          deine Angaben aus dem Formular inklusive der von dir dort angegebenen
          Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
          Anschlussfragen bei mir gespeichert. Diese Daten gebe ich nicht ohne
          deine Einwilligung weiter.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs.
          1 lit. b DSGVO (Anbahnung/Erfüllung eines Vertrags) bzw. Art. 6 Abs.
          1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung deiner
          Anfrage). Der Versand der E-Mail-Benachrichtigung erfolgt technisch
          über den Dienstleister Resend (Resend, Inc., 2261 Market Street
          #4667, San Francisco, CA 94114, USA) als Auftragsverarbeiter.
        </p>
        <p>
          Die von dir im Kontaktformular eingegebenen Daten verbleiben bei
          mir, bis du mich zur Löschung aufforderst, deine Einwilligung
          widerrufst oder der Zweck für die Datenspeicherung entfällt (z. B.
          nach abgeschlossener Bearbeitung deiner Anfrage). Zwingende
          gesetzliche Bestimmungen, insbesondere Aufbewahrungsfristen, bleiben
          unberührt.
        </p>
      </section>

      <section data-testid="ds-section-server-log">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          7. Server-Log-Dateien
        </h2>
        <p>
          Der Provider der Seiten erhebt und speichert automatisch
          Informationen in sogenannten Server-Log-Dateien, die dein Browser
          automatisch übermittelt. Dies sind: Browsertyp und -version,
          verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden
          Rechners, Uhrzeit der Serveranfrage und IP-Adresse. Eine
          Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
          vorgenommen.
        </p>
      </section>

      <section data-testid="ds-section-cookies">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          8. Cookies
        </h2>
        <p>
          Diese Website verwendet ausschließlich technisch notwendige Cookies,
          die für den Betrieb der Seite erforderlich sind. Analyse-, Tracking-
          oder Marketing-Cookies kommen derzeit nicht zum Einsatz.
        </p>
      </section>

      <section data-testid="ds-section-aenderungen">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          9. Änderungen dieser Datenschutzerklärung
        </h2>
        <p>
          Ich behalte mir vor, diese Datenschutzerklärung anzupassen, damit sie
          stets den aktuellen rechtlichen Anforderungen entspricht oder um
          Änderungen meiner Leistungen umzusetzen. Für deinen erneuten Besuch
          gilt dann die neue Datenschutzerklärung.
        </p>
      </section>
    </LegalLayout>
  );
}
